<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">添加库存</div>
          <div class="card-body">
            <!-- <Alert show-icon>仅支持为自动发货商品添加库存，例如：卡密、兑换码等虚拟物品</Alert> -->

            <Form ref="create" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem label="选择商品" prop="goods">
                <Spin size="large" v-if="data.length == 0"></Spin>
                <div v-else>
                  <div class="pictrueBox">
                    <div class="pictrue" v-for="item in data" :key="item.id" @click="changeGoods(item)"
                      :class="formValidate.goods.id == item.id ? 'active' : ''">
                      <img :src="item.front" alt="" />
                      <div class="text">{{ item.name }}</div>
                    </div>
                  </div>
                  <span>* 已选择商品：{{ formValidate.goods.name }}</span>
                  <Page :current="Number(current_page)" :total="Number(total)" :page-size="pageSize"
                    @on-change="pageChange" simple style="float: right" />
                </div>

              </FormItem>
              <FormItem label="选择规格" prop="norms">
                <RadioGroup v-model="formValidate.norms">
                  <Radio v-for="item in formValidate.goods.list" :key="item.id" :label="item.id">{{ item.name }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="备注" prop="remarks">
                <Input v-model="formValidate.remarks" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
                  placeholder="请添加本批库存备注"></Input>
              </FormItem>
              <FormItem label="分隔符" v-show="formValidate.goods.stocktype == 1">
                <RadioGroup v-model="formValidate.separator">
                  <Radio v-for="item in separatorList" :key="item.id" :label="item.id">{{ item.name }}</Radio>
                </RadioGroup>

                <Alert>仅作为批量添加库存时，系统区分每条库存时使用</Alert>
              </FormItem>
              <Divider />

              <FormItem label="库存内容" prop="code">
                <div v-show="formValidate.goods.stocktype == 1">
                  <Alert type="warning" style="display: inline-block; margin-right: 10px">{{ separatorRow.text }}
                  </Alert>
                  <Button type="info" style="height: 34px; margin-top: -2px"
                    @click="formValidate.code = separatorRow.value">查看示例</Button>
                </div>
                <div v-show="formValidate.goods.stocktype == 2">
                  <Alert>当前商品为无限库存商品，只需添加一条库存即可</Alert>
                </div>
                <Input v-model="formValidate.code" type="textarea" :autosize="{ minRows: 8, maxRows: 20 }"
                  placeholder="请添加库存内容"></Input>
              </FormItem>
              <FormItem label="是否去重" prop="repeat">
                <i-switch v-model="formValidate.repeat" />
              </FormItem>
              <FormItem>
                <Button type="primary" @click="addSave" :loading="loading">立即添加</Button>
              </FormItem>
            </Form>
          </div>

          <!-- end card body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStockShop,
    postStock
  } from "@/api/admin";

  export default {
    data() {
      return {
        formValidate: {
          goods: {},
          norms: "",
          code: "",
          remarks: "",
          separator: "",
          repeat: false,
        },
        separatorRow: {},
        separatorList: [{
            id: 1,
            name: "回车符",
            text: "当前分隔符为回车，每条库存之间用回车分割，也就是一行一个",
            value: "卡密：SDFSRFSSFSD\n卡密：SDFSDJFGSDJ\n卡密：JHSFEWUDU\n卡密：SDFSJEHFHU\n卡密：YGDSWYGDSS",
          },
          {
            id: 2,
            name: "### 号",
            text: "当前分隔符'###' 号，每条库存之间用'###'分开",
            value: "卡密：SDFSRFSSFSD###卡密：SDFSDJFGSDJ###卡密：JHSFEWUDU###卡密：SDFSJEHFHU###卡密：YGDSWYGDSS",
          },
          {
            id: 3,
            name: "&&& 号",
            text: "当前分隔符'&&&' 号，每条库存之间用'&&&'分开",
            value: "卡密：SDFSRFSSFSD&&&卡密：SDFSDJFGSDJ&&&卡密：JHSFEWUDU&&&卡密：SDFSJEHFHU&&&卡密：YGDSWYGDSS",
          },
        ],
        ruleValidate: {
          goods: [{
            required: true,
            message: "请选择商品"
          }],
          norms: [{
            required: true,
            message: "请选择规格"
          }],
          code: [{
            required: true,
            message: "请填写库存内容",
            trigger: "blur"
          }],
        },
        pageIndex: 1,
        pageSize: 10,
        total: "",
        current_page: "",
        data: [],
        loading: false
      };
    },
    created() {
      this._getStockShop();
      this.formValidate.separator = 1;
    },
    computed: {
      separator() {
        return this.formValidate.separator;
      },
    },

    watch: {
      separator(oldVal, newVal) {
        if (oldVal != newVal) {
          this.formValidate.code = "";
        }
        let that = this;
        this.separatorList.map(function (item) {
          if (that.formValidate.separator == item.id) {
            that.separatorRow = item;
          }
        });
      },
    },
    methods: {
      // 切换商品
      changeGoods(row){
         this.formValidate.goods = row
         this.formValidate.norms = ""
      },
      // 获取商品
      _getStockShop() {
        getStockShop({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }).then((res) => {
          this.data = res.data.data;
          this.formValidate.goods = res.data.data[0];

          this.total = res.data.total;
          this.current_page = res.data.current_page;
        });
      },
      // 新增方法
      addSave() {

        this.loading = true
        this.$refs.create.validate((valid) => {
          if (valid) {
            let arr = [];
            if (this.formValidate.goods.stocktype == 1) {
              // 卡密分割
              if (this.formValidate.separator == 1) {
                arr = this.formValidate.code.split("\n");
              } else if (this.formValidate.separator == 2) {
                arr = this.formValidate.code.split("###");
              } else if (this.formValidate.separator == 3) {
                arr = this.formValidate.code.split("&&&");
              }
            } else {
              arr.push(this.formValidate.code)
            }

            // 去重
            if (this.formValidate.repeat) {
              arr = this.removeRepeat(arr);
            }
            if (arr.length > 50) {
              this.$Message.error({
                background: true,
                content: "一次最多添加50条",
              });
              return;
            }
            postStock({
              goods_id: this.formValidate.goods.id,
              norms_id: this.formValidate.norms,
              content: arr,
              remarks: this.formValidate.remarks,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this.formValidate.code = ""
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
              this.loading = false

            });
          } else {
            this.$Message.warning({
              background: true,
              content: "请先补全带*的必填项",
            });
            this.loading = false

          }
        });
      },
      // 数组去重
      removeRepeat(arr) {
        var arr2 = arr.sort();
        var res = [arr2[0]];
        for (var i = 1; i < arr2.length; i++) {
          if (arr2[i] !== res[res.length - 1]) {
            res.push(arr2[i]);
          }
        }
        return res;
      },
      // 分页跳转
      pageChange(e) {
        this.pageIndex = e;
        this._getStockShop();
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  .help {
    margin-left: 10px;
    font-size: 20px;
    vertical-align: middle;
  }

  .card-body {
    padding-top: 10px;
  }

  .w50 {
    width: 50%;
  }

  .w80 {
    width: 80%;
  }

  .pictrueBox {
    display: block;
    margin-bottom: 10px;

    .active {
      border: 2px solid red;
      border-radius: 4px;
    }

    .pictrue {
      width: 74px;
      // height: 78px;
      display: inline-block;
      margin-right: 15px;
      margin-bottom: 10px;
      vertical-align: middle;
      cursor: pointer;
      position: relative;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        border-radius: 4px;
      }

      .text {
        height: 40px;
        line-height: 20px;
        font-size: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
</style>